<template>
  <div class="recharge-records">
    <div class="recharge-records-wrapper" v-show="recordsList.length">
      <list :finished="finished" @load="onLoad" finished-text="没有更多了" v-model="loading">
        <div :key="index" class="recharge-records-list" v-for="(record, index) in recordsList">
          <div :class="'intro-' + record.type" class="intro-common">
            <div class="intro">
              <p class="charge-phone">{{record.remark}}</p>
              <p class="charge-time">{{record.create_at}}</p>
            </div>
            <span :class="record.type" class="charge-money">{{type(record.type)}} {{record.rebate}}</span>
          </div>
        </div>
      </list>
    </div>
    <no-records v-show="noRecords && !recordsList.length"></no-records>
  </div>
</template>

<script>
import NoRecords from './NoData'
import { List } from 'vant'
let flag = false
export default {
  name: 'rechargeRecords',
  components: {
    NoRecords,
    List
  },
  data () {
    return {
      recordsList: [],
      noRecords: false,
      loading: false,
      finished: false,
      pageNum: 1
    }
  },
  computed: {
    type (type) {
      return type => {
        if (type === 'add') {
          return '+'
        } else if (type === 'sub') {
          return '-'
        }
      }
    }
  },
  created () {
    this.$toast.loading({
      message: '正在加载...',
      duration: 300000
    })
    this.getRecords()
  },
  methods: {
    onLoad () {
      if (flag) {
        return false
      }
      flag = true
      setTimeout(() => {
        this.getRecords(++this.pageNum).then(() => {
          this.loading = false
          flag = false
        })
      }, 500)
    },
    jumpDetails () { },
    async getRecords (pageNum) {
      const res = await this.$axios.get(`api/member/bill_love/${pageNum || 1}`)
      if (res.status === 200) {
        this.$toast.clear()
        const { code, data, msg } = res.data
        if (code === 0) {
          this.recordsList = [...this.recordsList, ...data]
        } else if (code === 9006) {
          if (this.pageNum === 1) {
            this.noRecords = true
          }
          this.finished = true
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.recharge-records-wrapper {
  padding: 0.3rem 0.2rem;
  background-color: #fff;
  .recharge-records-list {
    .intro {
      .charge-phone {
        font-size: @fz28;
        color: @base;
        padding-bottom: 0.18rem;
      }
      .charge-time {
        font-size: @fz24;
        color: #8c8c8c;
      }
    }

    .charge-money {
      font-size: @fz32;
    }
    .add {
      color: #ff9600;
    }
    .sub {
      color: #16a085;
    }
  }
  .intro-common {
    margin-top: 0.2rem;
    .flex-between;
    padding: 0.2rem;
    border-radius: 0.08rem;
  }
  .intro-add {
    background-color: #fff8db;
  }
  .intro-sub {
    background-color: #eef9ff;
  }
}
</style>
